import { FC, useCallback } from "react";
import {
    NotificationsIcon,
    ProfileIcon,
    RobotIcon,
    SecurityIcon,
} from "@icons";
import { useSettings } from "@components/settings/SettingsProvider";
import { Command } from "@vendor/cmdk/cmdk";
import { UserSettingsPages } from "@components/settings/constants";
import { SettingsCommandItem } from "./SettingsCommandItem";
import { useCommands } from "./useCommands";

export const AccountSettingsCommandList: FC = () => {
    const { open: openSettings } = useSettings();
    const { close: closeCommands } = useCommands();

    const handleSelected = useCallback(
        (path: string[]) => {
            closeCommands();
            setTimeout(() => {
                openSettings(path);
            }, 100);
        },
        [openSettings, closeCommands],
    );

    return (
        <Command.Group heading="Account settings">
            <SettingsCommandItem
                path={UserSettingsPages.GENERAL}
                onSelected={() => handleSelected([UserSettingsPages.GENERAL])}
            >
                <ProfileIcon /> Go to Profile
            </SettingsCommandItem>
            <SettingsCommandItem
                path={UserSettingsPages.NOTIFICATIONS}
                onSelected={() =>
                    handleSelected([UserSettingsPages.NOTIFICATIONS])
                }
            >
                <NotificationsIcon /> Go to Notifications
            </SettingsCommandItem>
            <SettingsCommandItem
                path={UserSettingsPages.SECURITY}
                onSelected={() => handleSelected([UserSettingsPages.SECURITY])}
            >
                <SecurityIcon /> Go to Security
            </SettingsCommandItem>
            <SettingsCommandItem
                path={UserSettingsPages.MCP_CLI}
                onSelected={() => handleSelected([UserSettingsPages.MCP_CLI])}
            >
                <RobotIcon /> Go to Connectors
            </SettingsCommandItem>
        </Command.Group>
    );
};
